export default __webpack_public_path__ + "static/media/rabidus-pert.12fa4dc5.png";